import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { PayByLinkError } from "@nju/feature-portal-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../components/ClientSideRenderer";

export default function PayByLinkErrorPage() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <ClientSideOnly>
          <RequiredDashboardData extendedMode="base">
            <Navigation />
            <PayByLinkError />
          </RequiredDashboardData>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
